import React from 'react';
import { motion } from 'framer-motion';
import { Gem, ArrowLeft } from 'lucide-react';
import SpecialTask2 from '../components/SpecialTask2';
import { Link } from 'react-router-dom';

const SpecialTask2Page: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto space-y-8">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        <div className="flex items-center justify-center mb-4">
          <Link 
            to="/special-tasks" 
            className="text-gray-300 hover:text-white flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Special Tasks
          </Link>
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          <span className="bg-gradient-to-r from-blue-400 via-cyan-500 to-teal-500 bg-clip-text text-transparent">
            SpecialTask2
          </span>
          <span className="ml-2 text-blue-500 animate-pulse">💎</span>
        </h1>
        <p className="text-xl text-gray-300 mb-6">
          Complete these premium tasks to earn 20 points per task daily!
        </p>
      </motion.div>

      {/* Special Task 2 - Premium Ad Tasks */}
      <SpecialTask2 />
    </div>
  );
};

export default SpecialTask2Page;